import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const BenchmarkGrid: React.FC = () => {
  return (
    <section style={{ padding: '80px 20px 100px', backgroundColor: '#121212' }}>
      <div className="container">
        
        {/* Centered micro1 Research Style Header */}
        <div style={{ textAlign: 'center', maxWidth: '780px', margin: '0 auto 56px' }}>
          <h2 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: 'clamp(28px, 4vw, 36px)',
              fontWeight: 400,
              color: '#FFFFFF',
              letterSpacing: '-0.5px',
              margin: '0 0 16px'
            }}
          >
            Research &amp; Benchmarks
          </h2>
          <p 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '15px',
              lineHeight: 1.65,
              color: '#D7D7D7',
              maxWidth: '680px',
              margin: '0 auto'
            }}
          >
            Our security lab is engineered to solve modern software&apos;s greatest coordination and identity challenges.
          </p>
        </div>

        {/* 3 Dark Benchmark Cards */}
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px',
            marginBottom: '48px'
          }}
        >
          {/* Card 1 */}
          <div 
            style={{
              backgroundColor: '#1A1A1A',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '8px',
              padding: '28px 24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 6px' }}>
                WebAuthn: Biometric assertion benchmark
              </h3>
              <p style={{ fontSize: '13px', color: '#9CA3AF', margin: '0 0 24px' }}>
                Evaluation of hardware biometrics across modern operating systems
              </p>

              {/* Benchmark Table Rows */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '28px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Apple TouchID / FaceID</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>100.0</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '100%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Windows Hello Biometrics</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>100.0</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '100%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>YubiKey FIDO2 Hardware</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>100.0</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '100%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>
              </div>
            </div>

            <Link 
              to="/security" 
              style={{
                fontSize: '12px',
                color: '#D7D7D7',
                border: '1px solid rgba(255, 255, 255, 0.12)',
                borderRadius: '4px',
                padding: '6px 12px',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'all 0.15s ease'
              }}
            >
              View benchmark
            </Link>
          </div>

          {/* Card 2 */}
          <div 
            style={{
              backgroundColor: '#1A1A1A',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '8px',
              padding: '28px 24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 6px' }}>
                Telephony: Delivery &amp; fraud resilience
              </h3>
              <p style={{ fontSize: '13px', color: '#9CA3AF', margin: '0 0 24px' }}>
                Evaluation of transactional OTP channels against telecom bot pumping
              </p>

              {/* Benchmark Table Rows */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '28px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>WhatsApp Business Cloud</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>98.4%</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '98.4%', height: '100%', backgroundColor: '#10B981' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Carrier SMS (DLT Routes)</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>92.1%</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '92.1%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Toll-Fraud Circuit Breaker</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>0.0% loss</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '100%', height: '100%', backgroundColor: '#10B981' }} />
                </div>
              </div>
            </div>

            <Link 
              to="/compare" 
              style={{
                fontSize: '12px',
                color: '#D7D7D7',
                border: '1px solid rgba(255, 255, 255, 0.12)',
                borderRadius: '4px',
                padding: '6px 12px',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'all 0.15s ease'
              }}
            >
              View benchmark
            </Link>
          </div>

          {/* Card 3 */}
          <div 
            style={{
              backgroundColor: '#1A1A1A',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '8px',
              padding: '28px 24px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 6px' }}>
                Latency: Edge local verification
              </h3>
              <p style={{ fontSize: '13px', color: '#9CA3AF', margin: '0 0 24px' }}>
                Performance benchmark of stateless JWT verification at network edge
              </p>

              {/* Benchmark Table Rows */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '28px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Cloudflare Workers JWKS</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>&lt; 1.2ms</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '96%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>Fastly Compute JWKS</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>&lt; 0.9ms</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '99%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <span style={{ color: '#D7D7D7' }}>AWS Lambda@Edge</span>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", color: '#FFFFFF', fontWeight: 500 }}>&lt; 2.1ms</span>
                </div>
                <div style={{ height: '3px', backgroundColor: 'rgba(255, 255, 255, 0.06)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ width: '90%', height: '100%', backgroundColor: '#6D7CFF' }} />
                </div>
              </div>
            </div>

            <Link 
              to="/docs" 
              style={{
                fontSize: '12px',
                color: '#D7D7D7',
                border: '1px solid rgba(255, 255, 255, 0.12)',
                borderRadius: '4px',
                padding: '6px 12px',
                textAlign: 'center',
                textDecoration: 'none',
                transition: 'all 0.15s ease'
              }}
            >
              View benchmark
            </Link>
          </div>

        </div>

        {/* Centered Button: View all research > */}
        <div style={{ textAlign: 'center' }}>
          <Link
            to="/docs"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#FFFFFF',
              color: '#121212',
              padding: '10px 20px',
              borderRadius: '9999px',
              fontSize: '13px',
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'all 0.15s ease'
            }}
          >
            <span>View all research</span>
            <div style={{
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              backgroundColor: '#121212',
              color: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <ChevronRight size={12} strokeWidth={2.5} />
            </div>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default BenchmarkGrid;
